import { Observable } from 'rxjs';
import { IFeatureFlags } from 'src/app/domain/interfaces/feature-flags/interface-feature-flags';

export abstract class FeatureFlagsGateway {
  abstract refresh(): Observable<IFeatureFlags>;
  abstract isEnabled(key: string): Observable<boolean>;
  abstract getAllFlags(): Observable<IFeatureFlags>;
}
